export const result = {};
// =IF(AND(C10>=90,C10<=100),"A+",IF(AND(C10>=80,C10<=89.9),"A",IF(AND(C10>=70,C10<=79.9),"B+",IF(AND(C10>=60,C10<=69.9),"B",IF(AND(C10>=50,C10<=59.9),"C+",IF(AND(C10>=40,C10<=49.9),"C","D"))))))
// =IF(AND(M10>=45,M10<=50),"A+",IF(AND(M10>=40,M10<=44.9),"A",IF(AND(M10>=35,M10<=39.9),"B+",IF(AND(M10>=30,M10<=34.9),"B",IF(AND(M10>=25,M10<=29.9),"C+",IF(AND(M10>=20,M10<=24.9),"C","D"))))))
export const computeGradeFromMarks = ({
  marks,
  fullMarks,
}: {
  marks: number;
  fullMarks: number;
}): string => {
  if (fullMarks === 100) {
    if (marks >= 90 && marks <= 100) return "A+";
    else if (marks >= 80 && marks <= 89.9) return "A";
    else if (marks >= 70 && marks <= 79.9) return "B+";
    else if (marks >= 60 && marks <= 69.9) return "B";
    else if (marks >= 50 && marks <= 59.9) return "C+";
    else if (marks >= 40 && marks <= 49.9) return "C";
    else return "D";
  }
  if (fullMarks === 50) {
    if (marks >= 45 && marks <= 50) return "A+";
    else if (marks >= 40 && marks <= 44.9) return "A";
    else if (marks >= 35 && marks <= 39.9) return "B+";
    else if (marks >= 30 && marks <= 34.9) return "B";
    else if (marks >= 25 && marks <= 29.9) return "C+";
    else if (marks >= 20 && marks <= 24.9) return "C";
    else return "D";
  }

  return "N/A";
};
